export const selectInvoiceItemsCreditNote = state => state.invoice.itemsCreditNote
export const selectInvoiceDealers = state => state.invoice.invoiceDealers
export const selectInvoiceIssuedByDealer = state => state.invoice.invoiceIssuedByDealer
export const selectInvoicePrintInstructions = state =>
  state.invoice.invoicePrintInstructions
